import React from "react";
import { Backdrop, CircularProgress } from "@mui/material";
import { useAuthContext } from "../context/AuthContext";

export default function Loading() {
  const { loading } = useAuthContext();
  return (
    <>
      <Backdrop
        sx={{
          backgroundColor: "transparent",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={loading}
      >
        <CircularProgress color="primary" />
      </Backdrop>
    </>
  );
}
